import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["children", "type", "variant", "onClick", "onMouseDown", "eventData", "width", "testId"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import * as React from 'react';
import { useContext } from 'react';
import { onlyText } from 'react-children-utilities';
import { AnalyticsContext, AnalyticsLocationConsumer, EventDataObject, trackEvent } from 'latitude-analytics';
import { BUTTON_STYLE, BUTTON_TYPE } from '@latitude/core/utils/constants';
import { StyledButton } from './Button.styled';
export const Button = _ref => {
  let {
      children,
      type = BUTTON_TYPE.BUTTON,
      variant = BUTTON_STYLE.PRIMARY,
      onClick,
      onMouseDown,
      eventData = {},
      width = 'auto',
      testId
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    0: analytics
  } = useContext(AnalyticsContext);
  const [tealiumDebugMode, setTealiumDebugMode] = React.useState(false);
  React.useEffect(() => {
    const isBrowser = typeof window !== "undefined";
    if (isBrowser) {
      setTealiumDebugMode(localStorage.getItem('tealiumDebugMode') || false);
    }
  }, []);
  const getTealiumDebugData = () => {
    const output = _objectSpread(_objectSpread(_objectSpread({}, analytics.siteData.page), analytics.pageData), _objectSpread({
      category: 'button-link',
      action: 'internal-link',
      label: onlyText(children)
    }, eventData));
    return JSON.stringify(output, null, 2);
  };
  const handleOnClick = (event, location) => {
    trackEvent(analytics, _objectSpread({
      category: 'button-link',
      action: 'internal-link',
      label: onlyText(children),
      location
    }, eventData));
    if (onClick) {
      onClick(event);
    }
  };
  return /*#__PURE__*/React.createElement(AnalyticsLocationConsumer, null, location => /*#__PURE__*/React.createElement(StyledButton, Object.assign({
    type: type,
    variant: variant,
    onClick: event => handleOnClick(event, location),
    onMouseDown: onMouseDown,
    width: width,
    "data-test-id": testId,
    title: tealiumDebugMode ? getTealiumDebugData(location) : null,
    tealiumDebugMode: tealiumDebugMode
  }, rest), children));
};
export default Button;